import { Route, Routes } from 'react-router-dom'

import { LogInPage } from '../pages'
import MyMenu from '../pages/public/MyMenu'

const AuthRouter = () => {
  return (
    <>
      <Routes>
        <Route element={<LogInPage />} path="/" />
        <Route element={<MyMenu />} path="/menu/:slug" />
        <Route element={<LogInPage />} path="*" />
      </Routes>
    </>
  )
}

export default AuthRouter
